/**
 * Created by denis.gusarov on 3/9/2017.
 */

namespace Factive.Game {

    import List = Factive.Core.Linq.List;
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;
    import Texture = PIXI.Texture;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    type EventType = dragonBones.EventObject;

    export class ButtonView extends ViewBase {
        public $model;
        private _buttonSprite: PIXI.Sprite;
        private _labelView: Factive.Game.LabelView;
        private _pressed: boolean;
        private tint: number;

        public get text(): string {
            return this._labelView.text;
        }

        public set text(value: string) {
            this._labelView.text = value;
        }

        public get style(): PIXI.TextStyle {
            return this._labelView.style;
        }

        public set style(value: PIXI.TextStyle) {
            this._labelView.style = value;
        }

        public get onPress(): Function {
            return this._options.onPress;
        }

        public set onPress(value: Function) {
            this._options.onPress = value;
        }

        public constructor(private _options) {
            super();
        }

        public static factory: any = {
            get (opt): ButtonView {
                return new ButtonView(opt);
            },
            dependency: ["Options"]
        };

        public getConfiguration(): IViewConfiguration {
            let textStyle = <PIXI.TextStyle>{
                fontFamily: this._options.fontFamily ? this._options.fontFamily : 'MLBArialNarrow',
                fontSize: this._options.fontSize ? this._options.fontSize : 22,
                fill: this._options.fill ? this._options.fill : '#FFFFFF'
            };

            if(this._options.fontWeight){
                textStyle.fontWeight = this._options.fontWeight;
            }

            if(this._options.wordWrap){
                textStyle.wordWrap = this._options.wordWrap;
            }
            if(this._options.wordWrapWidth){
                textStyle.wordWrapWidth = this._options.wordWrapWidth;
            }

            if(this._options.tint){
                this.tint = this._options.tint;
            }

            return <IViewConfiguration>{
                armatureName: "Button",
                sprites: {
                    button: "armature(button)"
                },
                spritesEvents: {
                    "touchstart $sprites.button": "_onMouseOver",
                    "tap $sprites.button": "_onMouseClickOrTap",
                    "touchendoutside $sprites.button": "_onMouseOut",
                    "mouseover $sprites.button": "_onMouseOver",
                    "mouseout $sprites.button": "_onMouseOut",
                    "click $sprites.button": "_onMouseClickOrTap"
                },
                animations: {
                    press: "press"
                },
                animationsEvents: {
                    "frameEvent $animations.press": "frameEvent",
                    "complete $animations.press": "animtionPressComplete"
                },
                childViews: {
                    labelView: {
                        view: "LabelView",
                        options: {
                            text: this._options.text,
                            slot: "button",
                            fontFamily: textStyle.fontFamily,
                            fontSize: textStyle.fontSize,
                            fill: textStyle.fill,
                            fontWeight: textStyle.fontWeight,
                            wordWrap: textStyle.wordWrap,
                            wordWrapWidth: textStyle.wordWrapWidth,
                        }
                    }
                }
            };
        }

        public onInitialize(): void {
            this._buttonSprite = this.$sprites.get("button");
            this.x = this._options.x;
            this.y = this._options.y;

            this._buttonSprite.tint = this.tint;

            this._labelView = this.$childViews.get<LabelView>("labelView");
        }

        private animtionPressComplete(event: EventType): void {

        }

        private frameEvent(event: EventType): void {
            if(event.name == "Pressed"){
                this._pressed = false;
                if(this._options.onPress){
                    this._options.onPress();
                }
            }
        }

        private _onMouseOver(event: PIXI.interaction.InteractionEvent): void {
        }

        private _onMouseOut(event: PIXI.interaction.InteractionEvent): void {
        }

        private _onMouseClickOrTap(event: PIXI.interaction.InteractionEvent): void {
            if(!this._pressed){
                this._pressed = true;
                this.$animations.get("press").play();
            }
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Controls/ButtonView.ts